(() => {
  if (customElements.get('bds-home')) return;
  customElements.define('bds-home', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.controller = new AbortController();
      const {signal} = this.controller;
      const track = this.querySelector('.bds-categories__track');
      const previous = this.querySelector('.bds-arrow--previous');
      const next = this.querySelector('.bds-arrow--next');
      if (!track || !previous || !next) return;
      const update = () => {
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = direction => track.scrollBy({
        left: direction * track.clientWidth,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
      previous.addEventListener('click', () => move(-1), {signal});
      next.addEventListener('click', () => move(1), {signal});
      track.addEventListener('scroll', update, {passive: true, signal});
      this.observer = new ResizeObserver(update);
      this.observer.observe(track);
      update();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }
  });
})();
